import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';

interface Props {
  onChangeGroup: () => void;
  onDelete: () => void;
}

export default function EmployeesActionsTableMenu({
  onChangeGroup,
  onDelete,
}: Props) {
  const { t } = useTranslation();

  const permissions = usePermissions();

  const actions: Action[] = [
    {
      id: 'changeGroup',
      label: t('employees:employees.actions.changeGroup'),
      onClick: onChangeGroup,
      disabled: permissions.cannot('changeGroup', 'Employees'),
      tooltip: t('common:notSufficientPermissions'),
    },
    {
      id: 'delete',
      label: t('employees:employees.actions.delete'),
      onClick: onDelete,
      disabled: permissions.cannot('delete', 'Employees'),
      tooltip: t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
}
